import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../../../../../../service'

export const useSaveInfographicBlockMutation = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await postNamedCommand('reports', 'save-infographic-block', body)
      return data
    }
  })
}
